const customerProfileRoutes = {
    CUSTOMER_PROFILE_DETAILS_UPDATE_MOBILE: {
        URL: '/v1/customer-profile/customer-details/update-mobile',
        METHOD: 'PATCH'
    },
}

const customerAuthLoginBypassRoutes = {
    BYPASS_AUTH: {
        URL: '/v1/auth/login/bypass-login',
        METHOD: 'POST',
    },
}

const customerMobileAuthRoutes = {
    MOBILE_AUTH_POST_MOBILE: {
        URL: 'v1/auth/login/check-mobile',
        METHOD: 'POST'
    },
    MOBILE_AUTH_POST_OTP: {
        URL: 'v1/auth/login/verify-otp',
        METHOD: 'POST'
    }
}

export const routes = {
    ...customerProfileRoutes,
    ...customerAuthLoginBypassRoutes,
    ...customerMobileAuthRoutes,
}